import {FunnelOrder} from 'common/report/funnels/models/constants';
import {ConversionWindow, CountType} from 'common/report/funnels/models/types';
import {Segmentation} from 'common/types/reports/query';

import {QueryEntry, QueryEventEntry, RowLabelType} from '../query-entry-section/types';

export type BuilderParams = {
  entries: QueryEntry[];
  exclusionSteps: QueryEventEntry[];
  dataGroupsEnabled: boolean;
  dataGroupId: string;
  projectHasPeople: boolean;
  projectHasCohorts: boolean;
  projectId: number;
  workspaceId: number;
  trackName: string;
  projectAsOfDate: string;
  entryRowLabelType: RowLabelType;
};

export type SelectedQueryOptions = {
  countType: CountType;
  holdingPropertyConstant: Segmentation[];
  funnelOrder: FunnelOrder;
  conversionWindow: ConversionWindow;
};

// TODO: a bit awkward that this component takes in exclusionSteps seperately via QueryBuilderAtttrs,
// yet emits them along with SelectedQueryOptions
export type QueryOptionsSelection = SelectedQueryOptions & {exclusionSteps?: QueryEventEntry[]};

export type QueryOptionsProps = {
  eventNames: string[];
  selected: SelectedQueryOptions;
  projectId: number;
  hideAnyOrder: boolean;
  hideConversionWindow: boolean;
  hideCountSelector?: boolean;
  showSessions: boolean;
  workspaceId: number;
  builderParams: BuilderParams;
  maxHoldingPropertyConstant: number;
  conversionWindowUnits: string[];
  conversionWindowSizeLimits: any;
  enableStickyHeader: boolean;
  onChangeQueryOption: (options: QueryOptionsSelection) => void;
  onTrack?: (data: any) => void;
};

export interface QueryOptionsState {
  conversionWindowErrorMsg: null | string;
  isConversionWindowMenuOpen: boolean;
  isConversionWindowMenuHovered: boolean;
  isCountTypeMenuOpen: boolean;
  isCountTypeMenuHovered: boolean;
  selectedValue: number;
  selectedUnit: string;
  holdingPropertyConstant: Segmentation[];
  stageHoldProps: boolean;
  stageExclusionSteps: boolean;
}

export enum ConversionCriteriaAction {
  ExcludeEvent = `excludeEvent`,
  HoldProperty = `holdProperty`,
}
